import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './MessageBar.css';

interface Props {
  messageKey: string;
  isError?: boolean;
}

const MessageBar: React.FC<Props> = ({ messageKey, isError = true }) => {
  const { t } = useTranslation();
  return (
    <div className={`message-container ${isError ? 'error' : 'info'}`} data-testid="message-bar">
      <span>
        {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
        <Trans
          t={t}
          i18nKey={messageKey}
          components={{
            supportLink: <a className="support-email" href="mailto:support@optibus.com" />,
          }}
        />
      </span>
    </div>
  );
};

export default MessageBar;
